// 国际化配置
import zh from './zh'
import en from './en'

const messages = {
  zh,
  en
}

// 获取浏览器语言
function getBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage
  if (lang.startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

// 获取保存的语言或浏览器语言
function getSavedLanguage() {
  return localStorage.getItem('language') || getBrowserLanguage()
}

// 保存语言设置
function saveLanguage(lang) {
  localStorage.setItem('language', lang)
}

// 创建响应式语言状态
import { reactive } from 'vue'

const state = reactive({
  currentLang: getSavedLanguage()
})

// 获取翻译
function t(key) {
  const keys = key.split('.')
  let value = messages[state.currentLang]
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k]
    } else {
      return key // 如果找不到翻译，返回 key
    }
  }
  
  return value || key
}

// 切换语言
function setLanguage(lang) {
  if (messages[lang]) {
    state.currentLang = lang
    saveLanguage(lang)
    // 更新页面标题
    document.title = t('site.title')
  }
}

// 获取当前语言
function getCurrentLanguage() {
  return state.currentLang
}

// 获取所有可用语言
function getAvailableLanguages() {
  return [
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ]
}

// Vue 插件
export default {
  install(app) {
    app.config.globalProperties.$t = t
    app.config.globalProperties.$setLanguage = setLanguage
    app.config.globalProperties.$getCurrentLanguage = getCurrentLanguage
    app.config.globalProperties.$getAvailableLanguages = getAvailableLanguages
    
    // 提供给组合式 API 使用
    app.provide('i18n', {
      t,
      setLanguage,
      getCurrentLanguage,
      getAvailableLanguages,
      state
    })
  }
}

export { t, setLanguage, getCurrentLanguage, getAvailableLanguages, state }
